// Installable app (PWA) switch. Set PWA_ENABLED = false and deploy to remove the service worker and its stored
// files from every phone and computer (the site keeps working as a normal website).
export const PWA_ENABLED = true;

const isProd = process.env.NODE_ENV === "production";
const UPDATE_EVENT = "sendtoo:update-available";

// the main bundle this page was loaded with, e.g. /static/js/main.1a2b3c.js
const loadedMain = () => {
  const s = Array.from(document.scripts).map((x) => x.src).find((src) => /\/static\/js\/main\.[^/]+\.js$/.test(src || ""));
  return s ? new URL(s).pathname : null;
};

// a new deploy is out if asset-manifest.json now points to a different main bundle
async function checkForUpdate() {
  const mine = loadedMain();
  if (!mine) return;
  try {
    const r = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: "no-store" });
    if (!r.ok) return;
    const latest = (await r.json())?.files?.["main.js"];
    if (latest && latest !== mine) window.dispatchEvent(new Event(UPDATE_EVENT));
  } catch { /* offline or blocked: try again later */ }
}

export function onUpdateAvailable(cb) {
  window.addEventListener(UPDATE_EVENT, cb);
  return () => window.removeEventListener(UPDATE_EVENT, cb);
}

export function setupPwa() {
  if (!("serviceWorker" in navigator)) return;
  if (!PWA_ENABLED) {
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister())).catch(() => {});
    if (window.caches) caches.keys().then((ks) => ks.filter((k) => k.startsWith("sendtoo-")).forEach((k) => caches.delete(k))).catch(() => {});
    return;
  }
  if (!isProd) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => { /* site works without it */ });
  });
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") checkForUpdate(); });
  setInterval(checkForUpdate, 30 * 60 * 1000);
}
